import { createApi } from "@reduxjs/toolkit/query/react";

import { Customer } from "../../../types";
import axiosBaseQuery from "../rtk-query-axios.service";
import { APP_BASE_URL, CUSTOMER_ENDPOINT } from "../../../Common/EndPoints";

type CustomerPostParams = {
  params: {
    customerTitle?: string;
    zoneCode: string;
    divisionCode: string;
    stnCode: string;
  };
};

type CustomerPutParams = {
  params: {
    id: string;
    zonecode: string;
    divisioncode: string;
    Customertitle?: string;
    Customername?: string;
  };
};

export const customerApi = createApi({
  reducerPath: "customerAPI",
  baseQuery: axiosBaseQuery,
  tagTypes: ["customer-list"],
  endpoints: (builder) => ({
    getCustomers: builder.query<Customer[], void>({
      query: (params) => ({
        url: APP_BASE_URL + CUSTOMER_ENDPOINT,
        method: "GET",
        params,
      }),
      providesTags: ["customer-list"],
      transformResponse: (_response: { error: any; success: any; data: Customer[] }): Customer[] => {
        const res = _response.data;
        res.sort((a, b) => (a.customerTitle ?? "")?.localeCompare(b.customerTitle ?? ""));
        return res;
      },
    }),
    postCustomer: builder.mutation<any, CustomerPostParams>({
      query: ({ params }: CustomerPostParams) => {
        return { url: APP_BASE_URL + CUSTOMER_ENDPOINT, params, method: "POST" };
      },
      invalidatesTags: ["customer-list"],
    }),
    editCustomer: builder.mutation<any, CustomerPutParams>({
      query: ({ params }: CustomerPutParams) => {
        return { url: APP_BASE_URL + CUSTOMER_ENDPOINT + `/${params.id}`, params, method: "PUT" };
      },
      invalidatesTags: ["customer-list"],
    }),
    deleteCustomer: builder.mutation<any, { params: { id: string } }>({
      query: ({ params }: { params: { id: string } }) => {
        return { url: APP_BASE_URL + CUSTOMER_ENDPOINT + `/${params.id}`, params, method: "DELETE" };
      },
      invalidatesTags: ["customer-list"],
    }),
  }),
});
